
export const asSeprerate = {
    data: `<svg width="1" height="32" viewBox="0 0 1 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="1" height="32" fill="#D9D9D9"/>
    </svg>`,
    name: 'seprerate',
  };
  